module.exports = __webpack_public_path__ + "img/left-register.7afda7b6.jpg";